var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErpIcons05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 91.19 91.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 89.87,
    y1: 45.6,
    x2: 4.08,
    y2: 45.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e73827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f85032"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 91.19,
    height: 91.19,
    rx: 21.22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.21,21.57H32a2.44,2.44,0,0,0-1.7.71,2.4,2.4,0,0,0-.7,1.7V67.22a2.39,2.39,0,0,0,.7,1.69,2.44,2.44,0,0,0,1.7.71H59.21a2.41,2.41,0,0,0,2.4-2.4V24a2.41,2.41,0,0,0-2.4-2.41ZM32,23.18H59.21a.79.79,0,0,1,.56.23A.8.8,0,0,1,60,24v4H31.18V24A.8.8,0,0,1,32,23.18Zm28,6.4v32H31.18v-32ZM59.21,68H32a.8.8,0,0,1-.8-.8v-4H60v4a.82.82,0,0,1-.8.8ZM44,64.81H47.2v1.61H44ZM34.39,40h6.4a.79.79,0,0,0,.8-.8V32.78a.79.79,0,0,0-.23-.56.82.82,0,0,0-.57-.24h-6.4a.8.8,0,0,0-.81.8v6.41a.82.82,0,0,0,.24.57A.79.79,0,0,0,34.39,40Zm.8-6.4H40v4.8h-4.8Zm1.6,1.6h1.6v1.6h-1.6ZM50.4,40h6.41a.79.79,0,0,0,.56-.23.82.82,0,0,0,.24-.57V32.78a.82.82,0,0,0-.8-.8H50.4a.8.8,0,0,0-.8.8v6.41a.79.79,0,0,0,.8.8Zm.8-6.4H56v4.8H51.2Zm1.6,1.6h1.6v1.6H52.8Zm-18.41,24h6.4a.82.82,0,0,0,.57-.24.79.79,0,0,0,.23-.56V52a.79.79,0,0,0-.23-.56.82.82,0,0,0-.57-.24h-6.4a.8.8,0,0,0-.81.8v6.41a.82.82,0,0,0,.81.8Zm.8-6.41H40v4.81h-4.8Zm1.6,1.6h1.6V56h-1.6ZM43.19,36V32H44.8v3.21h2.4a.79.79,0,0,1,.56.23A.8.8,0,0,1,48,36v4H46.4v-3.2H44A.8.8,0,0,1,43.19,36ZM48,33.59H46.4V32H48ZM44.8,40H43.19v-1.6H44.8ZM44,46.4H33.58V44.8h9.61V43.19H44.8V45.6a.82.82,0,0,1-.81.8Zm-8.8,3.2H33.58V48h1.61Zm1.6,0V48h1.6v1.6Zm8-.8v2.4H43.19V49.6H40V48h4a.79.79,0,0,1,.57.23A.82.82,0,0,1,44.8,48.8Zm-3.21-5.61h-8v-1.6h8ZM48,45.6H46.4v-4H48Zm-1.6,1.6H48v2.4H46.4Zm3.2,1.6V41.59h1.6V48h6.41v1.6H50.4A.8.8,0,0,1,49.6,48.8Zm8-6.41V45.6H56V43.19H53.6v-1.6h3.21a.82.82,0,0,1,.8.8ZM52.8,44.8h1.6v1.6H52.8Zm-5.6,6.4H57.61v1.6H48v6.41H46.4V52A.8.8,0,0,1,47.2,51.2Zm10.41,4v3.21a.82.82,0,0,1-.8.8H54.4v-1.6H56V56H50.4V54.4h6.41a.82.82,0,0,1,.8.8ZM50.4,57.61h2.4v1.6H50.4ZM43.19,52.8H44.8v6.41H43.19Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErpIcons05);
export default __webpack_public_path__ + "static/media/erp-icons-05.a09ece49c30c291d5a1d3eaabd4d7303.svg";
export { ForwardRef as ReactComponent };